<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="编辑人员">
      </el-page-header>
      <form class="form-horizontal" @submit.prevent="handleUserUpdate">
        <div class="panel-body">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label class="col-md-4 control-label">用户名</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ error: $v.user.name.$error }"
                    v-model="user.name"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">电话号码</label>
                <div class="col-md-8">
                  <input
                    type=""
                    class="form-control"
                    :class="{ error: $v.user.phone_number.$error }"
                    v-model="user.phone_number"
                  />
                </div>
              </div>
              <!-- <div class="form-group">
										<label class="col-md-4 control-label">密码</label>
										<div class="col-md-8">
											<input type="password" class="form-control" v-model='user.password'>
										</div>
									</div> -->
              <div class="form-group">
                <label class="col-md-4 control-label">角色</label>
                <div class="col-md-8">
                  <select
                    id="multiselect"
                    data-placeholder="角色选择"
                    multiple
                    tabindex="4"
                    v-model="user.role_ids"
                  >
                    <option
                      :value="item.id"
                      v-for="item in roles"
                      :key="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="col-md-8 col-md-offset-4">
                <button class="btn btn-success btn-labeled">保存</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {
  roleList,
  getFunctionModules,
  userInfo,
  userUpdate,
} from '@/service/getData'
import { required, maxLength } from 'vuelidate/lib/validators'

const rightPhoneNumber = (value) => /^1\d{10}$/gi.test(value)

export default {
  validations: {
    user: {
      name: {
        required,
        maxLength: maxLength(30),
      },
      phone_number: {
        required,
        rightPhoneNumber,
      },
    },
  },
  data() {
    return {
      user: {
        id: this.$route.params.id,
        name: '',
        password: '',
        phone_number: '',
        function_module_ids: [],
        role_ids: [],
      },
      modules: [],
      roles: [],
    }
  },
  mounted() {
    let that = this
    that.$nextTick(() => {
      $('#multiselect')
        .chosen({ width: '100%' })
        .change(function () {
          that.user.role_ids = $(this)
            .val()
            .map((item) => {
              return parseInt(item)
            })
        })
    })
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await userInfo(this.user.id)
      if (res.status != 0) return false
      let user = res.data
      user.function_module_ids = []
      user.role_ids = []
      user.function_modules.map((item) => {
        user.function_module_ids.push(item.function_module.id)
      })

      user.roles.map((item) => {
        user.role_ids.push(item.role_id)
      })
      this.user = user

      res = await getFunctionModules()
      if (res.status != 0) return false
      this.modules = res.data

      res = await roleList()
      this.roles = res.data

      this.$nextTick(() => {
        $('#multiselect').chosen({ width: '100%' }).trigger('chosen:updated')
      })
    },

    async handleUserUpdate() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      let res = await userUpdate(this.user)
      if (res.status == 0) {
        this.$router.go(-1)
      }
    },
  },
}
</script>